define("shared/components/shared/bttp/bttp-suggestions", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "moment", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _moment, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _configureTimeSlot, _checkTimeSlotIsWithinWindow;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"moment",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.canShowSuggestions}}
    <div
      class={{concat-classes
        "cPM--bttp-suggestions__container"
        "u--flex"
        "u--flex__row"
        (if @isMultiProfilePost "u--flex__wrap" "")
        "qa-bttp-suggestions-container"
      }}
      data-test-id="bttp-suggestions-container"
    >
      {{svg-jar "bttp" class="o--icon"}}
      <div class="u--flex u--flex__col u--m__l__xs u--m__r__sm">
        <span class="u--text--base u--text--bold u--flex u--flex__noWrap u--flex__alignItems--center">
          {{t "bttp.recommendation.title"}}
        </span>
        <span class="u--text--sm u--p--r__md u--ws--noWrap">
          {{t "bttp.recommendation.description"}}
        </span>
      </div>
  
      <div
        class={{concat-classes
          "cPM--bttp-suggestions__options"
          "u--flex"
          "u--flex__row"
          "u--flex__noWrap"
          (if @isMultiProfilePost "u--m__t__sm u--m__l__md")
          "qa-bttp-suggestions-options"
        }}
        data-test-id="bttp-suggestions-options"
      >
        {{#each this.availableTimeSlots as |timeSlot index|}}
          <Shared::Ui::Button
            @additional="rounded"
            @onClick={{fn this.handleUpdateScheduledTime timeSlot}}
            @size="small"
            @variant="outline"
            class="cPM--bttp-suggestions__option u--text--bold u--text--primary qa-bttp-suggestion-option-{{index}}"
            data-test-id="bttp-suggestions-option-{{index}}"
          >
            {{moment-format timeSlot "MMM D h:mmA"}}
          </Shared::Ui::Button>
        {{/each}}
      </div>
    </div>
  {{/if}}
  */
  {
    "id": "fKxtB8gw",
    "block": "[[[41,[30,0,[\"canShowSuggestions\"]],[[[1,\"  \"],[10,0],[15,0,[28,[37,1],[\"cPM--bttp-suggestions__container\",\"u--flex\",\"u--flex__row\",[52,[30,1],\"u--flex__wrap\",\"\"],\"qa-bttp-suggestions-container\"],null]],[14,\"data-test-id\",\"bttp-suggestions-container\"],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"bttp\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n    \"],[10,0],[14,0,\"u--flex u--flex__col u--m__l__xs u--m__r__sm\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--text--base u--text--bold u--flex u--flex__noWrap u--flex__alignItems--center\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"bttp.recommendation.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"u--text--sm u--p--r__md u--ws--noWrap\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"bttp.recommendation.description\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[15,0,[28,[37,1],[\"cPM--bttp-suggestions__options\",\"u--flex\",\"u--flex__row\",\"u--flex__noWrap\",[52,[30,1],\"u--m__t__sm u--m__l__md\"],\"qa-bttp-suggestions-options\"],null]],[14,\"data-test-id\",\"bttp-suggestions-options\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"availableTimeSlots\"]]],null]],null],null,[[[1,\"        \"],[8,[39,6],[[16,0,[29,[\"cPM--bttp-suggestions__option u--text--bold u--text--primary qa-bttp-suggestion-option-\",[30,3]]]],[16,\"data-test-id\",[29,[\"bttp-suggestions-option-\",[30,3]]]]],[[\"@additional\",\"@onClick\",\"@size\",\"@variant\"],[\"rounded\",[28,[37,7],[[30,0,[\"handleUpdateScheduledTime\"]],[30,2]],null],\"small\",\"outline\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,8],[[30,2],\"MMM D h:mmA\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[2,3]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@isMultiProfilePost\",\"timeSlot\",\"index\"],false,[\"if\",\"concat-classes\",\"svg-jar\",\"t\",\"each\",\"-track-array\",\"shared/ui/button\",\"fn\",\"moment-format\"]]",
    "moduleName": "shared/components/shared/bttp/bttp-suggestions.hbs",
    "isStrictMode": false
  });
  let BttpSuggestionsComponent = _exports.default = (_dec = (0, _service.inject)('calendar/bttp'), (_class = (_configureTimeSlot = /*#__PURE__*/new WeakSet(), _checkTimeSlotIsWithinWindow = /*#__PURE__*/new WeakSet(), class BttpSuggestionsComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _checkTimeSlotIsWithinWindow);
      _classPrivateMethodInitSpec(this, _configureTimeSlot);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "segment", _descriptor2, this);
      _initializerDefineProperty(this, "userConfig", _descriptor3, this);
      _initializerDefineProperty(this, "bttp", _descriptor4, this);
    }
    get currentTimeZoneIdentifier() {
      return this.userConfig.currentTimeZone.identifier;
    }
    get timeSlots() {
      return (this.args.socialProfile.bttpReport?.timeSlots || []).map(timeSlot => _classPrivateMethodGet(this, _configureTimeSlot, _configureTimeSlot2).call(this, timeSlot));
    }
    get canShowSuggestions() {
      // Only show suggestions when is using a single selected profile OR on growth plan (NOT during trial)
      const isValidMulti = this.args.isMultiProfilePost ? Boolean(this.auth.currentAccount.canMultipleBttp) : true;
      if (!this.availableTimeSlots.length || !isValidMulti) return false;
      const {
        socialProfile
      } = this.args;
      if (!this.bttp.canBttp(socialProfile.profileType)) return false;
      const isWithinWindow = this.timeSlots.some(timeSlot => {
        return this.scheduledTime?.isBetween(timeSlot, timeSlot.clone().add(1, 'hour'), undefined, '[)');
      });

      // Do not show if the post is already within the BTTP window
      return !isWithinWindow;
    }
    get scheduledTime() {
      const {
        post
      } = this.args;
      const scheduledTime = post.get('scheduledTime');
      return scheduledTime ? _moment.default.unix(scheduledTime) : undefined;
    }
    get availableTimeSlots() {
      return this.timeSlots.filter(timeSlot => _classPrivateMethodGet(this, _checkTimeSlotIsWithinWindow, _checkTimeSlotIsWithinWindow2).call(this, timeSlot)).slice(0, 3);
    }
    handleUpdateScheduledTime(timeSlot) {
      const {
        profileType
      } = this.args.socialProfile;
      if (profileType) {
        this.segment.track(`${profileType}-bttp-postbuilder`);
      }
      this.args.updateScheduledTime([], timeSlot.unix(), this.args.post);
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleUpdateScheduledTime", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleUpdateScheduledTime"), _class.prototype)), _class));
  function _configureTimeSlot2(timeSlot) {
    const configuredTimeSlot = (0, _moment.default)().clone().startOf('day').utc();
    configuredTimeSlot.day(timeSlot.wday || 0);
    configuredTimeSlot.hour(timeSlot.hour || 0);
    configuredTimeSlot.minute(timeSlot.minute || 0);
    configuredTimeSlot.tz(this.currentTimeZoneIdentifier);
    return configuredTimeSlot;
  }
  function _checkTimeSlotIsWithinWindow2(timeSlot) {
    const now = (0, _moment.default)().tz(this.currentTimeZoneIdentifier);
    const isAfterToday = timeSlot.isAfter(now);
    if (this.scheduledTime) {
      return isAfterToday && !this.scheduledTime.isBetween(timeSlot, timeSlot.clone().add(1, 'hour'), undefined, '[)');
    }
    return isAfterToday;
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BttpSuggestionsComponent);
});